import React from "react";
import "./Results.css";

const Results = ({
  title,
  courses,
  level,
  showAddButton = false,
  showNeedResultSlip = false,
  nextPage,
}) => {
  return (
    <div className="app_results">
      <div>
        <h2 className="result_title center font-semibold">{title}</h2>
        <p className="result_page center">
          <span>{level}</span>/<span>2</span>
        </p>
        <p>Your Result</p>
        <div className="result-div">
          {courses.map((course, index) => {
            return (
              <span key={index}>
                <p className="course_title capitalize">{course.subject}</p>
                <p>{course.grade}</p>
              </span>
            );
          })}
        </div>
        <button className="wide-btn btn mt-8" onClick={nextPage}>
          Next
        </button>
        {showAddButton && (
          <button className="outline btn">Add a second result</button>
        )}
        {showNeedResultSlip && (
          <p className="underlined">
            NEED ORIGINAL WAEC RESULT SLIP - CLICK HERE
          </p>
        )}
      </div>
    </div>
  );
};

export default Results;
